// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';

export const AnchorTag = styled(Anchor)`
  display: flex;
  padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  @media (max-width: 480px) {
    display: none;
  }
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  img {
    margin-top: 4px;
  }
`;

export const CountryLangName = styled.div`
  .countrySelector__locale--selected {
    color: ${(props) => props.theme.colors.WHITE} !important;
  }
  .countrySelector__locale--disabled {
    color: ${(props) => props.theme.colorPalette.gray['600']};
  }
  .countrySelector__locale {
    text-transform: uppercase;
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    :first-child {
      padding-left: 0;
    }

    :last-child {
      border: none;
    }
  }
`;
